<template>
  <a-modal
    :title="title"
    :width="1250"
    :visible="visible"
    ok-text="确定"
    cancel-text="取消"
    @ok="
      () => {
        $emit('ok');
      }
    "
    @cancel="
      () => {
        $emit('cancel');
      }
    "
  >
    <!-- v-if="showAugmentation || (showNetworkModelType && !showSeparate)"  -->
    <a-spin :spinning="dataLoading">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-col :span="12">
            <a-form-item label="网络模型类型">
              <a-select
                placeholder="请选择网络模型类型"
                v-decorator="[
                  'networkModelTypeId',
                  {
                    rules: [{ required: true, message: '请选择网络模型类型' }],
                  },
                ]"
              >
                <a-select-option
                  v-for="p in networkModelTypeList"
                  :key="p.id"
                  :value="p.id"
                >
                  {{ p.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="12" v-if="showNetworkModelType || showSeparate || showAugmentation"> -->
          <a-col :span="12">
            <a-form-item label="类别数">
              <a-input
                v-decorator="[
                  'numClass',
                  { rules: [{ required: true, message: '请输入类别数' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- ant-design-vue 3.2.16 版本可用
         <a-row>
          <a-col :span="12">
              <a-form-item label="资源库222">
                <a-cascader
                  placeholder="请选择"
                  multiple
                  v-model="value"
                  style="width: 100%"
                  :options="options"
                  :load-data="loadData"
                  max-tag-count="10"
                ></a-cascader>
              </a-form-item>
          </a-col>
        </a-row> -->

        <a-row>
          <a-col :span="12">
            <a-form-item label="资源库">
              <a-select
                mode="multiple"
                placeholder="请选择资源库"
                v-decorator="[
                  'pathIds',
                  { rules: [{ required: true, message: '请选择资源库' }] },
                ]"
                show-search
                option-filter-prop="children"
                @search="handleSearch"
                @popupScroll="handlePopupScroll"
                @select="handleSelect"
                :dropdownMatchSelectWidth="false"
              >
                <a-select-option
                  v-for="(p, index) in renderedOptions"
                  :key="index + 'p'"
                  :value="p.id"
                >
                  {{ p.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="训练次数">
              <a-input
                v-decorator="[
                  'trainFrequency',
                  { rules: [{ required: true, message: '请输入训练次数' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span="12">
          <a-form-item  label="输出模型">
              <a-select  placeholder="请选择模型" v-decorator="['modelNum']">
                <a-select-option v-for="p in modelList" :key="p.id" :value="p.id">
                  {{ p.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row> -->
        <a-row>
          <a-col :span="12">
            <a-form-item label="批处理量">
              <a-input v-decorator="['cbatchSize']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="学习率">
              <a-input v-decorator="['clr']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="批处理量(输出)">
              <a-input v-decorator="['outputBatchSize']" />
            </a-form-item>
          </a-col>

          <a-col :span="12" v-if="showSeparate">
            <a-form-item label="步数">
              <a-input v-decorator="['stride']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="图像高度">
              <a-input v-decorator="['imageHeight']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="图像宽度">
              <a-input v-decorator="['imageWidth']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="旋转增强">
              <a-select v-decorator="['rotateAugmentation']">
                <a-select-option :key="0" :value="0"> 否 </a-select-option>
                <a-select-option :key="1" :value="1"> 是 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="颜色增强">
              <a-select v-decorator="['colourAugmentation']">
                <a-select-option :key="0" :value="0"> 否 </a-select-option>
                <a-select-option :key="1" :value="1"> 是 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="生成BModel">
              <a-select
                v-decorator="['generateBmodel']"
                @select="selectGenerateBmodel"
              >
                <a-select-option :key="0" :value="0"> 否 </a-select-option>
                <a-select-option :key="1" :value="1"> 是 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="BModel的bchw" v-if="showBchw">
              <a-input
                v-decorator="['bmodelBchw']"
                placeholder="请用空格进行分割"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="showBchw">
            <a-form-item label="1684x">
              <a-select v-decorator="['bm1684x']">
                <a-select-option :key="0" :value="0"> 否</a-select-option>
                <a-select-option :key="1" :value="1"> 是 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="半监督模式">
              <a-select
                v-decorator="['semiSupervisedFlag']"
                @select="selectSemiSupervisedFlag"
              >
                <a-select-option :key="0" :value="0"> 否 </a-select-option>
                <a-select-option :key="1" :value="1"> 是 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row v-if="showSemiSupervised">
          <a-col :span="12">
            <a-form-item label="半监督训练次数">
              <a-input v-decorator="['semiSupervisedTrainCount']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="半监督训练阈值">
              <a-input v-decorator="['semiSupervisedTrainThreshold']" />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span="12">
            <a-form-item label="decay_frequency">
              <a-input v-decorator="['decayFrequency']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="decay_factor">
              <a-input v-decorator="['decayFactor']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="brightness_factor_start">
              <a-input v-decorator="['brightnessFactorStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="brightness_factor_end">
              <a-input v-decorator="['brightnessFactorEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="add_factor_start"> <a-input v-decorator="['addFactorStart']" /> </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="add_factor_end">
              <a-input v-decorator="['addFactorEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="hue_val_start">
              <a-input v-decorator="['hueValStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="hue_val_end">
              <a-input v-decorator="['hueValEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="translate_ptx_start">
              <a-input v-decorator="['translatePtxStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="translate_ptx_end">
              <a-input v-decorator="['translatePtxEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="translate_pty_start">
              <a-input v-decorator="['translatePtyStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="translate_pty_end"> <a-input v-decorator="['translatePtyEnd']" /> </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="rotation_angle_start">
              <a-input v-decorator="['rotationAngleStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="rotation_angle_end">
              <a-input v-decorator="['rotationAngleEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="rotation_scale_start">
              <a-input v-decorator="['rotationScaleStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="rotation_scale_end">
              <a-input v-decorator="['rotationScaleEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="contrast_factor_start">
              <a-input v-decorator="['contrastFactorStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="contrast_factor_end">
              <a-input v-decorator="['contrastFactorEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="use_gray">
              <a-input v-decorator="['useGray']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="pool_rate">
              <a-input v-decorator="['poolRate']" />
            </a-form-item>
          </a-col>
        </a-row> -->
        <!-- <a-row>
          <a-col :span="12">
            <a-form-item label="use_gray">
              <a-input type="hiden" v-decorator="['id']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="pool_rate">
              <a-input type="hiden" v-decorator="['taskId']" />
            </a-form-item>
          </a-col>
        </a-row> -->
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from "lodash.pick";
import { requestUrl } from "@/utils/request_url";
import * as networkmodel from "@/api/networkmodel_management";
import * as networkmodeltype from "@/api/networkmodeltype_management";
import request from "@utils/request";

import debounce from "lodash/debounce";

const fields = [
  // 'networkModelId',
  "outputBatchSize",
  "colourAugmentation",
  "rotateAugmentation",
  "networkModelTypeId",
  "numClass",
  "pathIds",
  "modelNum",
  "trainFrequency",
  "cbatchSize",
  "clr",
  "imageHeight",
  "imageWidth",
  "decayFrequency",
  "decayFactor",
  "brightnessFactorStart",
  "brightnessFactorEnd",
  "addFactorStart",
  "addFactorEnd",
  "saturationFactorStart",
  "saturationFactorEnd",
  "hueValStart",
  "hueValEnd",
  "translatePtxStart",
  "translatePtxEnd",
  "translatePtyStart",
  "translatePtyEnd",
  "rotationAngleStart",
  "rotationAngleEnd",
  "rotationScaleStart",
  "rotationScaleEnd",
  "contrastFactorStart",
  "contrastFactorEnd",
  "useGray",
  "poolRate",
  "id",
  "taskId",
  "stride",
  "semiSupervisedFlag",
  "semiSupervisedTrainCount",
  "semiSupervisedTrainThreshold",
  "generateBmodel",
  "bmodelBchw",
  "bm1684x",
];

const LOAD_NUM = 100;

const obj = {
  id: -1,
  name: "点击加载更多",
};

export default {
  name: "TrainConfig",
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    model: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: "新增",
    },
    showrow: {
      type: Boolean,
      default: () => true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    showNetworkModelType: {
      type: Boolean,
      required: true,
    },
    showAugmentation: {
      type: Boolean,
      default: () => false,
    },
    showSeparate: {
      type: Boolean,
      default: () => false,
    },

    // networkModelList: {
    //   type: Array,
    //   default: () => null,
    // },
    networkModelTypeList: {
      type: Array,
      default: () => null,
    },
    resourceList: {
      type: Array,
      default: () => null,
    },
    projectList: {
      type: Array,
      default: () => null,
    },
    projectId: {
      type: Number,
      default: () => {},
    },
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 6 },
        sm: { span: 13 },
      },
    };
    return {
      form: this.$form.createForm(this),
      headers: {},
      hiden: false,
      modelList: [
        {
          name: "模型1",
          id: 1,
        },
        {
          name: "模型2",
          id: 2,
        },
      ],
      showSemiSupervised: false,
      showBchw: false,
      // 渲染的  双向绑定的数据+动态加载  ant-design-vue 3.2.16
      // options: [],
      // value: [],
      // loadData:{},
      dataLoading: false,
      searchVal: "",
      renderedOptions: [],
      oriDataList: [],
      filterDataList: [],
      // 添加点击更多标识
      flag: false,
    };
  },
  created() {
    fields.forEach((v) => this.form.getFieldDecorator(v));
    this.$watch("model", () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields));
      if (this.model.generateBmodel != null && this.model.generateBmodel == 1) {
        this.showBchw = true;
      } else {
        this.showBchw = false;
      }
      if (
        this.model.semiSupervisedFlag != null &&
        this.model.semiSupervisedFlag == 1
      ) {
        this.showSemiSupervised = true;
      } else {
        this.showSemiSupervised = false;
      }

      // 利用浅克隆slice处理
      this.renderedOptions = this.resourceList.slice(0);
      this.oriDataList = this.resourceList.slice(0);
      if (Object.prototype.hasOwnProperty.call(this.model, "pathIds")) {
        this.dataLoading = true;
        const self = this;
        this.loadResourceList(this.projectId).then((res) => {
          self.dataLoading = false;
          let list = res.data;
          var map = new Map();
          for (var index in list) {
            map.set(list[index].id, list[index].name);
          }
          self.model.pathIds.forEach((e) => {
            if (map.has(e)) {
              let obj = {
                id: e,
                name: map.get(e),
              };
              self.renderedOptions.push(obj);
              self.oriDataList.push(obj);
            }
          });
          this.renderedOptions.push(obj);
        });
      } else {
        this.dataLoading = false;
        this.renderedOptions.push(obj);
      }
    });

    // 动态加载
    // this.loadData = selectedOptions =>{
    // const targetOption = selectedOptions[selectedOptions.length - 1]
    // targetOption.loading = true
    // const self = this;
    // setTimeout( () => {
    //   targetOption.loading = false;
    //   this.loadResourceList(targetOption.value).then((res) =>{
    //     let array = [];
    //     if(res.data.list != null){
    //       res.data.list.forEach(item=>{
    //         let obj = {
    //           value:item.id,
    //           label:item.name,
    //         }
    //         array.push(obj);
    //       })
    //       array.sort((a, b) =>
    //         a.label.localeCompare(b.label, "zh-Hans-CN", {
    //           sensitivity: "accent",
    //         })
    //       );
    //     }
    //     targetOption.children = [...array];
    //     self.options = [...self.options];
    //   });
    // }, 1000);
    // }
  },

  // watch: {
  //   imageUrl: function (val) {
  //     debugger
  //   },
  // },
  computed: {},
  mounted() {
    // if(this.model.generateBmodel!=null&& this.model.generateBmodel==1){
    //    this.showBchw=true;
    // }
    // else{
    //    this.showBchw=false;
    // }
  },
  methods: {
    selectGenerateBmodel(val) {
      if (val === 1) this.showBchw = true;
      else this.showBchw = false;
    },
    selectSemiSupervisedFlag(val) {
      if (val === 1) {
        this.showSemiSupervised = true;
      } else {
        this.showSemiSupervised = false;
      }
    },

    async loadResourceList(currentProjectId) {
      const resultData = [];
      const dataUrl =
        requestUrl +
        "/train/rest/label_file/get_label_resource_list_new/" +
        currentProjectId;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });
        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },

    // 文本框值变化时触发
    handleSearch(val) {
      this.searchVal = val;
      let filterList = [];
      if (val) {
        filterList = this.oriDataList.filter(
          (item) => item.name.indexOf(val) > -1
        );
      } else {
        filterList = this.oriDataList;
      }
      if (!this.flag) {
        filterList.push(obj);
      }
      this.filterDataList = filterList;
      this.renderedOptions =
        filterList.length < LOAD_NUM
          ? filterList
          : filterList.slice(0, LOAD_NUM);
    },
    // 滚动时触发（防止抖动）
    handlePopupScroll: debounce(function () {
      if (this.searchVal === "") {
        this.loadMoreData(this.oriDataList);
      } else {
        this.loadMoreData(this.filterDataList);
      }
    }, 400),
    // 加载更多数据到select框
    loadMoreData(dataList) {
      const renderedLen = this.renderedOptions.length; // 已渲染的下拉列表长度
      const totalLen = dataList.length; // 当前数据源的长度
      let addList = [];
      if (renderedLen < totalLen) {
        if (renderedLen + LOAD_NUM <= totalLen) {
          addList = dataList.slice(renderedLen, renderedLen + LOAD_NUM);
        } else {
          addList = dataList.slice(
            renderedLen,
            renderedLen + (totalLen % LOAD_NUM)
          );
        }
        this.renderedOptions = this.renderedOptions.concat(addList);
      }
    },
    // 被选中时调用，参数为选中项的 value (或 key) 值
    handleSelect(val) {
      // 表示选择点击更多
      if (val === -1) {
        this.flag = true;
        const self = this;
        self.dataLoading = true;
        this.loadResourceList(this.projectId).then((res) => {
          const choiseNode = document.getElementsByClassName(
            "ant-select-selection__choice"
          );
          Array.from(choiseNode).forEach((item) => {
            if (item.innerText.indexOf("点击加载更多") > -1) {
              item.remove();
            }
          });
          self.dataLoading = false;
          let list = [];
          if (Object.prototype.hasOwnProperty.call(this.model, "pathIds")) {
            // 剔除list中存在的，避免重复
            for (var i = 0; i < res.data.length; i++) {
              let item = res.data[i];
              if (this.model.pathIds.indexOf(item.id) === -1) {
                list.push(item);
              }
            }
          } else {
            list = res.data;
          }
          list.forEach((item) => {
            self.oriDataList.push(item);
          });
          let originalLenth = self.renderedOptions.length - 1;
          self.renderedOptions = self.renderedOptions.slice(0, originalLenth);
          list.slice(0, LOAD_NUM - originalLenth).forEach((item) => {
            self.renderedOptions.push(item);
          });
        });
      } else {
        if (this.searchVal) {
          const selectedArr = this.oriDataList.filter(
            (item) => item.id === val
          ); // 从数据源中过滤出下拉框选中的值，并返回一个数组
          const restList = this.oriDataList.filter((item) => item.id !== val); // 从数据源中过滤出其他的值，返回一个数组
          const newList = selectedArr.concat(restList).slice(0, LOAD_NUM); // 将选中的元素放到下拉列表的第一位
          this.renderedOptions = newList; // 更新已渲染的下拉列表
          if (!this.flag) {
            this.renderedOptions.push(obj);
          }
          this.oriDataList = selectedArr.concat(restList); // 更新数据源
          this.searchVal = ""; // 因为触发handleSelect函数时，会自动清空用户输入的内容。因此，searchVal需要重置。
        }
      }
    },
  },
};
</script>
